import React from 'react';
import { CFBaseIconVariant } from '../utilities';
export const CFIconUmbrella = {
    alias: 'umbrella',
    defaultTitle: 'Umbrella',
    source: ({ Path }, { variant }) => variant === CFBaseIconVariant.FILLED ? (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M12 2C6.486 2 2 6.486 2 12a1 1 0 0 0 1 1h8v6c0 1.654 1.346 3 3 3s3-1.346 3-3a1 1 0 1 0-2 0 1 1 0 0 1-2 0v-6h8a1 1 0 0 0 1-1c0-5.514-4.486-10-10-10Z' }))) : (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M4.063 11c.493-3.94 3.865-7 7.936-7 4.074 0 7.446 3.06 7.938 7H4.063ZM12 2C6.487 2 2 6.486 2 12a1 1 0 0 0 1.001 1H11v6c0 1.654 1.346 3 3.001 3 1.654 0 3-1.346 3-3a1 1 0 1 0-2 0 1.001 1.001 0 0 1-2 0v-6H21a1 1 0 0 0 1-1c0-5.514-4.486-10-10-10Z' }))),
};
